import { Box, Button, Chip, MenuItem, Select, TextField, Typography } from "@mui/material";
import { blue, green, orange, purple, red } from "@mui/material/colors";
import { useMemo, useState } from "react";
import moment from "moment";

const brands = ["Rare Rabbit", "Rareism", "Rare Ones", "Rarez"];
const categories = ["Shirts", "Trousers", "Dresses", "T-Shirts", "Footwear", "Bags", "Belts", "Kidswear"];
const vendors = [
	{
		name: "Radhamani Textiles Pvt Ltd (UNIT 1)",
		id: "OWN-UNIT-1",
		city: "Bengaluru",
		score: 96,
		capacity: 90000,
		lead: 24,
		quality: 95,
		cost: "Internal",
		special: ["Shirts", "Trousers", "Dresses", "T-Shirts", "Kidswear", "Bags", "Belts", "Footwear"],
	},
	{
		name: "Apex Garments Pvt Ltd",
		id: "V00981",
		city: "Bengaluru",
		score: 93,
		capacity: 52000,
		lead: 28,
		quality: 94,
		cost: "Low",
		special: ["Shirts", "Trousers", "T-Shirts"],
	},
	{
		name: "Lotus Stitch Works",
		id: "V01720",
		city: "Noida",
		score: 84,
		capacity: 34000,
		lead: 32,
		quality: 89,
		cost: "Low",
		special: ["Dresses", "Kidswear"],
	},
	{
		name: "Stride Footwear Co.",
		id: "V02114",
		city: "Agra",
		score: 81,
		capacity: 18000,
		lead: 42,
		quality: 86,
		cost: "Medium",
		special: ["Footwear"],
	},
	{
		name: "Urban Leather Works",
		id: "V01888",
		city: "Mumbai",
		score: 79,
		capacity: 15000,
		lead: 35,
		quality: 88,
		cost: "High",
		special: ["Bags", "Belts"],
	},
];
const stages = [
	"Design Created",
	"Vendor Allocated",
	"PO Done",
	"Fabric Inhouse",
	"Cutting",
	"Stitching",
	"Finishing/QC",
	"Dispatched",
	"GRN Done",
];

function rng(seed) {
	let s = seed % 2147483647;
	if (s <= 0) s += 2147483646;
	return () => {
		s = (s * 16807) % 2147483647;
		return (s - 1) / 2147483646;
	};
}

const r = rng(77);
const styleNames = [
	"Oxford Stripe Shirt",
	"Linen Resort Shirt",
	"Slim Chino",
	"Cargo Trouser",
	"Floral Wrap Dress",
	"Pintuck Kurti",
	"Kids Zip Jogger",
	"Runner Pro Sneaker",
	"Classic Leather Belt",
	"Structured Tote",
	"Merino Crewneck",
	"Club Collar Shirt",
	"Denim Jacket",
	"Pleated Midi Skirt",
	"Canvas Slip-on",
	"Travel Trolley",
	"Dinosaur Tee",
	"Formal Derby",
];
const today = new Date("2026-05-17");
const addDays = (d, n) => {
	const x = new Date(d);
	x.setDate(x.getDate() + n);
	return x;
};
const fmtDate = (d) => moment(d).format("DD MMM YYYY");
const money = (value) => {
	const v = Number(value) || 0;
	if (v >= 10000000) return `Rs ${(v / 10000000).toFixed(2)} Cr`;
	if (v >= 100000) return `Rs ${(v / 100000).toFixed(1)} L`;
	return `Rs ${v.toLocaleString("en-IN")}`;
};
const n = (value) => Number(value).toLocaleString("en-IN");

const stylesSeed = Array.from({ length: 36 }, (_, i) => {
	const cat = categories[Math.floor(r() * categories.length)];
	const brand = brands[Math.floor(r() * brands.length)];
	const qty = Math.round(600 + r() * 3400);
	const rate = Math.round(450 + r() * 2300);
	const st = stages[Math.floor(r() * stages.length)];
	const vendor = vendors.filter((v) => v.special.includes(cat))[0]?.name || vendors[Math.floor(r() * vendors.length)].name;
	const drop = addDays(today, Math.round(7 + r() * 60));
	const design = addDays(today, -Math.round(5 + r() * 45));
	const prodType = i % 5 === 0 ? "Own Production" : i % 3 === 0 ? "Job Work" : "FOB";
	const finalVendor = prodType === "Own Production" ? "Radhamani Textiles Pvt Ltd (UNIT 1)" : vendor;
	const docPrefix = prodType === "FOB" ? "PO" : prodType === "Job Work" ? "JO" : "INT";
	return {
		id: i + 1,
		code: (brand === "Rare Rabbit" ? "RR" : brand === "Rareism" ? "RM" : brand === "Rare Ones" ? "RO" : "RZ") + "-" + (2500 + i),
		name: styleNames[i % styleNames.length],
		brand,
		cat,
		qty,
		rate,
		value: qty * rate,
		status: st,
		vendor: finalVendor,
		prodType,
		docType: prodType === "FOB" ? "Purchase Order" : prodType === "Job Work" ? "Job Order" : "Internal Production Order",
		poNo: i % 3 === 0 ? `RR/${docPrefix}/${String(8120 + i)}/25-26` : "Pending",
		drop,
		design,
		delayRisk: Math.round(r() * 100),
		margin: Math.round(54 + r() * 18),
		priority: r() > 0.72 ? "High" : r() > 0.45 ? "Medium" : "Normal",
	};
});

const groupBy = (arr, fn) =>
	arr.reduce((acc, item) => {
		const key = fn(item);
		if (!acc[key]) acc[key] = [];
		acc[key].push(item);
		return acc;
	}, {});

const tabs = [
	{ key: "allocation", label: "Vendor Allocation" },
	{ key: "po", label: "Generate PO" },
	{ key: "tracking", label: "Production Tracking" },
	{ key: "reporting", label: "Reporting" },
	{ key: "intelligence", label: "AI Insights" },
];

const ProductionAllocation = () => {
	const [search, setSearch] = useState("");
	const [brandFilter, setBrandFilter] = useState("");
	const [catFilter, setCatFilter] = useState("");
	const [prodTypeFilter, setProdTypeFilter] = useState("");
	const [vendorFilter, setVendorFilter] = useState("");
	const [statusFilter, setStatusFilter] = useState("");
	const [dropFilter, setDropFilter] = useState("");
	const [activeTab, setActiveTab] = useState("allocation");
	const [selectedStyles, setSelectedStyles] = useState([1, 2, 4]);
	const [selectedVendor, setSelectedVendor] = useState(vendors[1].name);

	const filtered = useMemo(() => {
		const q = search.trim().toLowerCase();
		return stylesSeed.filter((s) => {
			const matchesQuery = !q || [s.code, s.name, s.vendor, s.poNo].join(" ").toLowerCase().includes(q);
			const matchesBrand = !brandFilter || s.brand === brandFilter;
			const matchesCat = !catFilter || s.cat === catFilter;
			const matchesType = !prodTypeFilter || s.prodType === prodTypeFilter;
			const matchesVendor = !vendorFilter || s.vendor === vendorFilter;
			const matchesStatus = !statusFilter || s.status === statusFilter;
			const matchesDrop = !dropFilter || moment(s.drop).diff(moment(today), "days") <= Number(dropFilter);
			return matchesQuery && matchesBrand && matchesCat && matchesType && matchesVendor && matchesStatus && matchesDrop;
		});
	}, [search, brandFilter, catFilter, prodTypeFilter, vendorFilter, statusFilter, dropFilter]);

	const kpis = useMemo(() => {
		const poDone = filtered.filter((s) => s.poNo !== "Pending").length;
		const delayed = filtered.filter((s) => s.delayRisk > 72).length;
		const upcoming = filtered.filter((s) => moment(s.drop).diff(moment(today), "days") <= 30).length;
		const value = filtered.reduce((a, s) => a + s.value, 0);
		return {
			designs: filtered.length,
			poDone,
			value,
			upcoming,
			delayed,
			avgMargin: filtered.length ? Math.round(filtered.reduce((a, s) => a + s.margin, 0) / filtered.length) : 0,
		};
	}, [filtered]);

	const vendorGroups = useMemo(() => groupBy(filtered, (s) => s.vendor), [filtered]);
	const categoryGroups = useMemo(() => groupBy(filtered, (s) => s.cat), [filtered]);
	const selectedRows = filtered.filter((s) => selectedStyles.includes(s.id));
	const selectedVendorRow = vendors.find((v) => v.name === selectedVendor) || vendors[0];
	const docKind = selectedRows.every((s) => s.prodType === "Job Work")
		? "JO"
		: selectedRows.every((s) => s.prodType === "Own Production")
			? "INT"
			: "PO";
	const docLabel = docKind === "JO" ? "Job Order" : docKind === "INT" ? "Internal Production Order" : "Purchase Order";
	const poTotal = selectedRows.reduce((a, s) => a + s.value, 0);
	const poGst = Math.round(poTotal * 0.18);

	const toggleStyle = (id) => {
		setSelectedStyles((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
	};

	const handleSelectVendor = (name) => {
		setSelectedVendor(name);
		if (name === "Radhamani Textiles Pvt Ltd (UNIT 1)") {
			setSelectedStyles((prev) => (prev.length ? prev : [1, 2, 4]));
		}
	};

	return (
		<Box
			sx={{
				bgcolor: "#f7f7f5",
				color: "#111110",
				minHeight: "100vh",
				p: 3,
				fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
			}}>
			<style>{`
				.pa-shell{min-height:calc(100vh - 24px)}
				.pa-main{max-width:1440px;margin:0 auto}
				.pa-topbar{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:18px;gap:12px;flex-wrap:wrap;padding-bottom:14px;border-bottom:1px solid rgba(0,0,0,.08)}
				.pa-title{font-size:30px;font-weight:700;line-height:1.1;letter-spacing:-.02em;color:#111110}
				.pa-tagline{color:#6b6b68;font-size:12px;margin-top:4px}
				.pa-actions{display:flex;gap:8px;flex-wrap:wrap}
				.pa-btn{border:1px solid rgba(0,0,0,.12);background:#fff;border-radius:22px;padding:7px 14px;font-size:11px;text-transform:none;color:#111110}
				.pa-btn.primary{background:#111110;color:#fff;border-color:#111110}
				.pa-btn.gold{background:#eceae5;color:#111110;border-color:rgba(0,0,0,.12)}
				.pa-filters{background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:14px;padding:12px;display:grid;grid-template-columns:1.1fr repeat(6,minmax(110px,1fr)) auto;gap:8px;align-items:center;margin-bottom:16px;box-shadow:0 4px 18px rgba(0,0,0,.04)}
				.pa-kpis{display:grid;grid-template-columns:repeat(6,1fr);gap:10px;margin-bottom:16px}
				.pa-kpi{background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:14px;padding:14px 15px;box-shadow:0 4px 18px rgba(0,0,0,.04)}
				.pa-k-label{font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:#6b6b68;margin-bottom:7px}
				.pa-k-val{font-size:25px;font-weight:700;line-height:1;color:#111110}
				.pa-k-sub{font-size:10px;color:#9b9b97;margin-top:5px}
				.pa-tabs{display:flex;gap:6px;border-bottom:1px solid rgba(0,0,0,.08);padding-bottom:10px;margin-bottom:14px;flex-wrap:wrap}
				.pa-tab{font-size:11px;padding:7px 12px;border-radius:8px;cursor:pointer;color:#6b6b68;background:transparent;border:0}
				.pa-tab.active{background:#111110;color:#fff}
				.pa-panel{background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:14px;padding:17px 18px;box-shadow:0 4px 18px rgba(0,0,0,.04)}
				.pa-grid2{display:grid;grid-template-columns:1fr 1fr;gap:14px;margin-bottom:14px}
				.pa-grid3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px;margin-bottom:14px}
				.pa-table{width:100%;border-collapse:collapse}
				.pa-table th{font-size:10px;color:#9b9b97;font-weight:500;text-align:left;padding:0 7px 8px;border-bottom:1px solid rgba(0,0,0,.08);white-space:nowrap}
				.pa-table th.num,.pa-table td.num{text-align:right}
				.pa-table td{font-size:11px;color:#3a3a38;padding:8px 7px;border-bottom:1px solid rgba(0,0,0,.08);vertical-align:middle}
				.pa-table tr:hover td{background:#f2f1ee}
				.pa-table td strong{font-weight:600;color:#111110}
				.pa-vendor-card,.pa-stage,.pa-idea{border:1px solid rgba(0,0,0,.08);border-radius:12px;background:#fff}
				.pa-vendor-card{padding:13px;cursor:pointer;transition:.15s}
				.pa-vendor-card:hover,.pa-vendor-card.selected{border-color:#111110;box-shadow:0 0 0 3px rgba(17,17,16,.08)}
				.pa-v-head{display:flex;justify-content:space-between;gap:8px}
				.pa-v-name{font-weight:600;color:#111110;font-size:12px}
				.pa-v-meta{font-size:10px;color:#9b9b97;margin-top:3px}
				.pa-score{font-size:24px;font-weight:700;color:#16784f}
				.pa-v-row{display:grid;grid-template-columns:1fr 1fr;gap:7px;margin-top:10px}
				.pa-v-cell{background:#f2f1ee;border-radius:8px;padding:8px}
				.pa-v-cell .l{font-size:9px;color:#9b9b97;text-transform:uppercase}
				.pa-v-cell .v{font-size:12px;color:#111110;font-family:monospace;margin-top:3px}
				.pa-stage{padding:12px}
				.pa-stage .s-icon{width:28px;height:28px;border-radius:8px;display:flex;align-items:center;justify-content:center;margin-bottom:9px}
				.pa-stage .s-title{font-size:11px;font-weight:600}
				.pa-stage .s-val{font-size:24px;font-weight:700;margin-top:5px}
				.pa-stage .s-sub{font-size:10px;color:#9b9b97}
				.pa-po-preview{border:1px solid rgba(0,0,0,.14);background:#fff;border-radius:12px;overflow:hidden}
				.pa-po-head{padding:16px;border-bottom:1px solid rgba(0,0,0,.08);display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap}
				.pa-po-title{font-size:18px;font-weight:700}
				.pa-po-company{font-weight:700}
				.pa-po-small{font-size:10px;color:#6b6b68;line-height:1.5}
				.pa-po-body{padding:16px}
				.pa-po-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:12px}
				.pa-po-box{border:1px solid rgba(0,0,0,.08);border-radius:8px;padding:10px}
				.pa-po-box .l{font-size:9px;text-transform:uppercase;color:#9b9b97;letter-spacing:.07em;margin-bottom:5px}
				.pa-po-box .v{font-size:11px;color:#3a3a38;line-height:1.55}
				.pa-po-total{display:flex;justify-content:flex-end;padding:12px 16px;border-top:1px solid rgba(0,0,0,.08);font-size:12px}
				.pa-po-total strong{font-size:20px;font-weight:700;margin-left:12px}
				.pa-idea{border-left:3px solid #111110;padding:15px}
				.pa-idea .icon{width:32px;height:32px;border-radius:9px;display:flex;align-items:center;justify-content:center;margin-bottom:10px}
				.pa-idea h3{font-size:13px;margin-bottom:5px}
				.pa-idea p{font-size:11px;color:#6b6b68;line-height:1.55}
				@media(max-width:1100px){
					.pa-kpis{grid-template-columns:repeat(2,1fr)}
					.pa-filters{grid-template-columns:1fr 1fr}
					.pa-grid2,.pa-grid3{grid-template-columns:1fr}
				}
			`}</style>

			<div className="pa-shell">
				<main className="pa-main">
					<div className="pa-topbar">
						<div>
							<div className="pa-tagline">
								Vendor allocation | Style-wise PO generation | Production milestone tracking | Drop reporting
							</div>
						</div>
						<div className="pa-actions">
							<Button className="pa-btn">Import Designs</Button>
							<Button className="pa-btn">Export Report</Button>
							<Button className="pa-btn primary">Generate PO / JO</Button>
						</div>
					</div>

					<div className="pa-filters">
						<TextField
							size="small"
							placeholder="Search style, vendor, PO..."
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
						<Select size="small" displayEmpty value={brandFilter} onChange={(e) => setBrandFilter(e.target.value)}>
							<MenuItem value="">All brands</MenuItem>
							{brands.map((brand) => (
								<MenuItem key={brand} value={brand}>
									{brand}
								</MenuItem>
							))}
						</Select>
						<Select size="small" displayEmpty value={catFilter} onChange={(e) => setCatFilter(e.target.value)}>
							<MenuItem value="">All categories</MenuItem>
							{categories.map((category) => (
								<MenuItem key={category} value={category}>
									{category}
								</MenuItem>
							))}
						</Select>
						<Select size="small" displayEmpty value={prodTypeFilter} onChange={(e) => setProdTypeFilter(e.target.value)}>
							<MenuItem value="">All production types</MenuItem>
							<MenuItem value="FOB">FOB</MenuItem>
							<MenuItem value="Job Work">Job Work</MenuItem>
							<MenuItem value="Own Production">Own Production</MenuItem>
						</Select>
						<Select size="small" displayEmpty value={vendorFilter} onChange={(e) => setVendorFilter(e.target.value)}>
							<MenuItem value="">All vendors</MenuItem>
							{vendors.map((vendor) => (
								<MenuItem key={vendor.name} value={vendor.name}>
									{vendor.name}
								</MenuItem>
							))}
						</Select>
						<Select size="small" displayEmpty value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
							<MenuItem value="">All statuses</MenuItem>
							<MenuItem value="Design Created">Design Created</MenuItem>
							<MenuItem value="Vendor Allocated">Vendor Allocated</MenuItem>
							<MenuItem value="PO Done">PO Done</MenuItem>
							<MenuItem value="Fabric Inhouse">Fabric Inhouse</MenuItem>
							<MenuItem value="Finishing/QC">Finishing/QC</MenuItem>
							<MenuItem value="Dispatched">Dispatched</MenuItem>
						</Select>
						<Select size="small" displayEmpty value={dropFilter} onChange={(e) => setDropFilter(e.target.value)}>
							<MenuItem value="">All drops</MenuItem>
							<MenuItem value="15">Next 15 days</MenuItem>
							<MenuItem value="30">Next 30 days</MenuItem>
							<MenuItem value="45">Next 45 days</MenuItem>
						</Select>
						<Button
							className="pa-btn gold"
							onClick={() => {
								setSearch("");
								setBrandFilter("");
								setCatFilter("");
								setProdTypeFilter("");
								setVendorFilter("");
								setStatusFilter("");
								setDropFilter("");
							}}>
							Reset
						</Button>
					</div>

					<div className="pa-kpis">
						{[
							["Designs Created", kpis.designs, "filtered styles"],
							[
								"Order Docs Done",
								kpis.poDone,
								`${kpis.designs ? Math.round((kpis.poDone / kpis.designs) * 100) : 0}% conversion`,
							],
							["Production Value", money(kpis.value), `${n(filtered.reduce((a, s) => a + s.qty, 0))} units`],
							["Expected Drops", kpis.upcoming, "next 30 days"],
							["Delay Risk", kpis.delayed, "styles need action"],
							["Avg Margin", `${kpis.avgMargin}%`, "estimated intake margin"],
						].map(([label, value, sub]) => (
							<div className="pa-kpi" key={label}>
								<div className="pa-k-label">{label}</div>
								<div className="pa-k-val">{value}</div>
								<div className="pa-k-sub">{sub}</div>
							</div>
						))}
					</div>

					<div className="pa-tabs">
						{tabs.map((tab) => (
							<button
								key={tab.key}
								className={`pa-tab ${activeTab === tab.key ? "active" : ""}`}
								onClick={() => setActiveTab(tab.key)}>
								{tab.label}
							</button>
						))}
					</div>

					{activeTab === "allocation" && (
						<div className="pa-grid2">
							<div className="pa-panel">
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "baseline",
										marginBottom: 12,
									}}>
									<Typography variant="h6" sx={{ fontWeight: 700 }}>
										Style-wise vendor allocation
									</Typography>
									<Typography variant="caption" color="text.secondary">
										select one or multiple styles
									</Typography>
								</div>
								<table className="pa-table">
									<thead>
										<tr>
											<th />
											<th>Style</th>
											<th>Type</th>
											<th>Brand</th>
											<th>Category</th>
											<th className="num">Qty</th>
											<th className="num">Value</th>
											<th>Status</th>
											<th>Drop</th>
										</tr>
									</thead>
									<tbody>
										{filtered.slice(0, 18).map((s) => (
											<tr key={s.id}>
												<td>
													<input
														type="checkbox"
														checked={selectedStyles.includes(s.id)}
														onChange={() => toggleStyle(s.id)}
													/>
												</td>
												<td>
													<strong>{s.code}</strong>
													<br />
													<span style={{ color: "#9b9b97", fontSize: 10 }}>{s.name}</span>
												</td>
												<td>
													<Chip
														size="small"
														label={s.prodType}
														sx={{
															bgcolor:
																s.prodType === "FOB"
																	? blue[50]
																	: s.prodType === "Job Work"
																		? orange[50]
																		: green[50],
															color:
																s.prodType === "FOB"
																	? blue[900]
																	: s.prodType === "Job Work"
																		? orange[900]
																		: green[900],
														}}
													/>
												</td>
												<td>{s.brand}</td>
												<td>{s.cat}</td>
												<td className="num">{n(s.qty)}</td>
												<td className="num">{money(s.value)}</td>
												<td>
													<Chip
														size="small"
														label={s.status}
														sx={{ bgcolor: "#f2f1ee", color: "#3a3a38" }}
													/>
												</td>
												<td>{fmtDate(s.drop)}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							<div className="pa-panel">
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "baseline",
										marginBottom: 12,
									}}>
									<Typography variant="h6" sx={{ fontWeight: 700 }}>
										Recommended vendors
									</Typography>
									<Typography variant="caption" color="text.secondary">
										capacity + quality + cost score
									</Typography>
								</div>
								<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
									{vendors.map((vendor) => {
										const fit = [
											...new Set(filtered.filter((s) => vendor.special.includes(s.cat)).map((s) => s.cat)),
										].length;
										const score = Math.min(99, vendor.score + fit * 8);
										return (
											<div
												key={vendor.name}
												className={`pa-vendor-card ${vendor.name === selectedVendor ? "selected" : ""}`}
												onClick={() => handleSelectVendor(vendor.name)}>
												<div className="pa-v-head">
													<div>
														<div className="pa-v-name">{vendor.name}</div>
														<div className="pa-v-meta">
															{vendor.id} | {vendor.city}
														</div>
													</div>
													<div className="pa-score">{score}</div>
												</div>
												<div className="pa-v-row">
													<div className="pa-v-cell">
														<div className="l">Capacity</div>
														<div className="v">{n(vendor.capacity)}</div>
													</div>
													<div className="pa-v-cell">
														<div className="l">Lead time</div>
														<div className="v">{vendor.lead}d</div>
													</div>
													<div className="pa-v-cell">
														<div className="l">Quality</div>
														<div className="v">{vendor.quality}%</div>
													</div>
													<div className="pa-v-cell">
														<div className="l">Cost</div>
														<div className="v">{vendor.cost}</div>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					)}

					{activeTab === "po" && (
						<div className="pa-grid2">
							<div className="pa-panel">
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "baseline",
										marginBottom: 12,
									}}>
									<Typography variant="h6" sx={{ fontWeight: 700 }}>
										PO / Job Order draft
									</Typography>
									<Typography variant="caption" color="text.secondary">
										PO layout for FOB, Job Work, internal order for own production
									</Typography>
								</div>
								<div className="pa-po-preview">
									<div className="pa-po-head">
										<div>
											<div className="pa-po-company">RADHAMANI TEXTILES PVT LTD.</div>
											<div className="pa-po-small">Reg. Office: VTMS Arcade, Hosur Main Road, Bangalore</div>
										</div>
										<div style={{ textAlign: "right" }}>
											<div className="pa-po-title">{docLabel}</div>
											<div className="pa-po-small">
												Order No: <strong>{selectedRows[0]?.poNo || "RR/PO/AUTO/25-26"}</strong>
												<br />
												Date: {fmtDate(today)}
											</div>
										</div>
									</div>
									<div className="pa-po-body">
										<div className="pa-po-grid">
											<div className="pa-po-box">
												<div className="l">Vendor</div>
												<div className="v">
													{selectedVendorRow.name}
													<br />
													{docLabel} for {selectedRows.length || 0} style(s)
												</div>
											</div>
											<div className="pa-po-box">
												<div className="l">Delivery</div>
												<div className="v">
													Expected Drop:{" "}
													{fmtDate(selectedRows.length ? selectedRows[selectedRows.length - 1].drop : today)}
												</div>
											</div>
										</div>
										<table className="pa-table">
											<thead>
												<tr>
													<th>Group / Item</th>
													<th>HSN</th>
													<th className="num">Rate</th>
													<th className="num">Qty</th>
													<th>UOM</th>
													<th className="num">Basic Amount</th>
												</tr>
											</thead>
											<tbody>
												{selectedRows.slice(0, 8).map((s) => (
													<tr key={s.id}>
														<td>
															<strong>{s.code}</strong>
															<br />
															{s.name}
														</td>
														<td>62052090</td>
														<td className="num">{n(s.rate)}</td>
														<td className="num">{n(s.qty)}</td>
														<td>PCS</td>
														<td className="num">{money(s.value)}</td>
													</tr>
												))}
												<tr>
													<td colSpan={3}>
														<strong>Total</strong>
													</td>
													<td className="num">
														<strong>{n(selectedRows.reduce((a, s) => a + s.qty, 0))}</strong>
													</td>
													<td />
													<td className="num">
														<strong>{money(poTotal)}</strong>
													</td>
												</tr>
												<tr>
													<td colSpan={5}>Integrated GST (IGST) @ 18%</td>
													<td className="num">{money(poGst)}</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="pa-po-total">
										Net Amount <strong>{money(poTotal + poGst)}</strong>
									</div>
								</div>
							</div>
							<div className="pa-panel">
								<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
									PO controls
								</Typography>
								<div className="pa-grid3" style={{ gridTemplateColumns: "1fr", marginBottom: 0 }}>
									{[
										["Draft", filtered.filter((s) => s.poNo === "Pending").length, blue[50], blue[900]],
										[
											"Approval",
											filtered.filter((s) => s.status === "Design Created").length,
											orange[50],
											orange[900],
										],
										["Released", filtered.filter((s) => s.poNo !== "Pending").length, green[50], green[900]],
										[
											"In Production",
											filtered.filter((s) => s.prodType !== "Own Production").length,
											purple[50],
											purple[900],
										],
										["Dispatched", filtered.filter((s) => s.status === "Dispatched").length, blue[50], blue[900]],
										["Received", filtered.filter((s) => s.status === "GRN Done").length, green[50], green[900]],
									].map(([label, value, bg, color]) => (
										<div key={label} className="pa-stage">
											<div className="s-icon" style={{ background: bg, color }}>
												•
											</div>
											<div className="s-title">{label}</div>
											<div className="s-val">{value}</div>
											<div className="s-sub">workflow summary</div>
										</div>
									))}
								</div>
								<div style={{ marginTop: 14, display: "grid", gap: 10 }}>
									<Button className="pa-btn primary">Generate PO / Job Order from selected styles</Button>
									<Button className="pa-btn">Send for approval</Button>
									<Button className="pa-btn">Send to vendor</Button>
								</div>
							</div>
						</div>
					)}

					{activeTab === "tracking" && (
						<>
							<div className="pa-grid3">
								<div className="pa-panel">
									<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
										Production stage funnel
									</Typography>
									<div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8 }}>
										{["Design Created", "PO Done", "GRN Done"].map((label, idx) => {
											const counts = [
												filtered.length,
												filtered.filter((s) => s.poNo !== "Pending").length,
												filtered.filter((s) => s.status === "GRN Done").length,
											];
											return (
												<div key={label} className="pa-stage" style={{ background: "#fafaf8" }}>
													<Typography
														variant="caption"
														sx={{ color: "#6b6b68", textTransform: "uppercase", letterSpacing: ".08em" }}>
														{label}
													</Typography>
													<Typography variant="h4" sx={{ fontWeight: 700, color: "#111110", mt: 0.5 }}>
														{counts[idx]}
													</Typography>
												</div>
											);
										})}
									</div>
								</div>
								<div className="pa-panel">
									<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
										Expected drop calendar
									</Typography>
									<table className="pa-table">
										<thead>
											<tr>
												<th>Drop Date</th>
												<th className="num">Styles</th>
												<th className="num">Value</th>
											</tr>
										</thead>
										<tbody>
											{Object.entries(groupBy(filtered, (s) => fmtDate(s.drop)))
												.slice(0, 8)
												.map(([date, rows]) => (
													<tr key={date}>
														<td>{date}</td>
														<td className="num">{rows.length}</td>
														<td className="num">{money(rows.reduce((a, s) => a + s.value, 0))}</td>
													</tr>
												))}
										</tbody>
									</table>
								</div>
								<div className="pa-panel">
									<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
										Delay risk radar
									</Typography>
									<div style={{ display: "grid", gap: 10 }}>
										{[
											["Low", filtered.filter((s) => s.delayRisk <= 45).length, green[50], green[800]],
											[
												"Medium",
												filtered.filter((s) => s.delayRisk > 45 && s.delayRisk <= 72).length,
												orange[50],
												orange[800],
											],
											["High", filtered.filter((s) => s.delayRisk > 72).length, red[50], red[800]],
										].map(([label, count, bg, color]) => (
											<div
												key={label}
												className="pa-stage"
												style={{
													background: bg,
													display: "flex",
													justifyContent: "space-between",
													alignItems: "center",
												}}>
												<Typography variant="subtitle2" sx={{ color, fontWeight: 700 }}>
													{label}
												</Typography>
												<Typography variant="h5" sx={{ color, fontWeight: 700 }}>
													{count}
												</Typography>
											</div>
										))}
									</div>
								</div>
							</div>
							<div className="pa-panel">
								<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
									Style production tracker
								</Typography>
								<table className="pa-table">
									<thead>
										<tr>
											<th>Style</th>
											<th>Type</th>
											<th>Vendor</th>
											<th>Document</th>
											<th>Status</th>
											<th>Design Created</th>
											<th>Expected Drop</th>
											<th className="num">Delay Risk</th>
										</tr>
									</thead>
									<tbody>
										{filtered.map((s) => (
											<tr key={s.id}>
												<td>
													<strong>{s.code}</strong>
													<br />
													<span style={{ color: "#9b9b97", fontSize: 10 }}>{s.name}</span>
												</td>
												<td>
													<Chip
														size="small"
														label={s.prodType}
														sx={{
															bgcolor:
																s.prodType === "FOB"
																	? blue[50]
																	: s.prodType === "Job Work"
																		? orange[50]
																		: green[50],
															color:
																s.prodType === "FOB"
																	? blue[900]
																	: s.prodType === "Job Work"
																		? orange[900]
																		: green[900],
														}}
													/>
												</td>
												<td>{s.vendor}</td>
												<td>{s.poNo}</td>
												<td>
													<Chip
														size="small"
														label={s.status}
														sx={{ bgcolor: "#f2f1ee", color: "#3a3a38" }}
													/>
												</td>
												<td>{fmtDate(s.design)}</td>
												<td>{fmtDate(s.drop)}</td>
												<td className="num">
													<Chip
														size="small"
														label={`${s.delayRisk}%`}
														sx={{
															bgcolor:
																s.delayRisk > 72 ? red[50] : s.delayRisk > 45 ? orange[50] : green[50],
															color:
																s.delayRisk > 72
																	? red[800]
																	: s.delayRisk > 45
																		? orange[800]
																		: green[800],
														}}
													/>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</>
					)}

					{activeTab === "reporting" && (
						<div className="pa-grid2">
							<div className="pa-panel">
								<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
									Vendor-wise PO count
								</Typography>
								<table className="pa-table">
									<thead>
										<tr>
											<th>Vendor</th>
											<th className="num">Styles</th>
											<th className="num">Value</th>
										</tr>
									</thead>
									<tbody>
										{Object.entries(vendorGroups)
											.map(([vendor, rows]) => ({
												vendor,
												styles: new Set(rows.map((s) => s.code)).size,
												value: rows.reduce((a, s) => a + s.value, 0),
											}))
											.sort((a, b) => b.value - a.value)
											.slice(0, 8)
											.map((row) => (
												<tr key={row.vendor}>
													<td>{row.vendor}</td>
													<td className="num">{row.styles}</td>
													<td className="num">{money(row.value)}</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
							<div className="pa-panel">
								<Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
									Category production value
								</Typography>
								<table className="pa-table">
									<thead>
										<tr>
											<th>Category</th>
											<th className="num">Styles</th>
											<th className="num">Value</th>
										</tr>
									</thead>
									<tbody>
										{Object.entries(categoryGroups)
											.map(([category, rows]) => ({
												category,
												styles: new Set(rows.map((s) => s.code)).size,
												value: rows.reduce((a, s) => a + s.value, 0),
											}))
											.sort((a, b) => b.value - a.value)
											.slice(0, 8)
											.map((row) => (
												<tr key={row.category}>
													<td>{row.category}</td>
													<td className="num">{row.styles}</td>
													<td className="num">{money(row.value)}</td>
												</tr>
											))}
									</tbody>
								</table>
							</div>
						</div>
					)}

					{activeTab === "intelligence" && (
						<div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14 }}>
							{[
								{
									title: "Production risk escalation",
									desc: `${filtered.filter((s) => s.delayRisk > 72).length} styles are above high-risk threshold. Escalate vendor follow-up and move QC earlier.`,
									color: red[700],
								},
								{
									title: "Document conversion gap",
									desc: `${filtered.filter((s) => s.poNo === "Pending").length} PO drafts are still pending. Generate final docs for approved styles.`,
									color: purple[700],
								},
								{
									title: "Vendor capacity optimization",
									desc: `Keep the highest value vendor under control by splitting future allocations when a vendor crosses 35% of seasonal value.`,
									color: green[700],
								},
								{
									title: "Drop readiness check",
									desc: `Confirm fabric inhouse, packaging, and dispatch readiness 7 days before the earliest delivery date in this filter set.`,
									color: blue[700],
								},
								{
									title: "Category concentration",
									desc: `Use category filters to monitor value concentration across categories before final PO release.`,
									color: orange[700],
								},
								{
									title: "Split vendor strategy",
									desc: `For high quantity styles, consider a 70:30 allocation split between primary and backup vendors.`,
									color: "#a16207",
								},
							].map((item) => (
								<div key={item.title} className="pa-idea" style={{ borderLeftColor: item.color }}>
									<div className="icon" style={{ background: `${item.color}18`, color: item.color }}>
										•
									</div>
									<h3>{item.title}</h3>
									<p>{item.desc}</p>
								</div>
							))}
						</div>
					)}
				</main>
			</div>
		</Box>
	);
};

export default ProductionAllocation;
